import { Component, ViewChild, Injector, Output, EventEmitter, ElementRef, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, NgForm } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';
import { UserServiceProxy, ProfileServiceProxy, UserRoleDto, UserMemberEditDto, MemberCategoryEditDto, DocumentationEditDto, UserViewDto, } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { CorreiosService } from '@app/shared/common/correios/correios.service';
import { AppCorrespondenceSituation, AppPhoneType, DocumentationStatusMember, StatusIntegracao } from '@shared/AppEnums';

import * as _ from 'lodash';

@Component({
    selector: 'visualizeUserModal',
    templateUrl: './visualize-user-modal.component.html'
})
export class VisualizeUserModalComponent extends AppComponentBase {

    phoneType = AppPhoneType;
    appCorrespondenceSituation = AppCorrespondenceSituation;
    documentationStatusMember = DocumentationStatusMember;
    statusIntegracao = StatusIntegracao;

    @ViewChild('userForm') public userForm: NgForm;
    @ViewChild('createOrEditModal') modal: ModalDirective;

    active = false;

    user: UserViewDto = new UserViewDto();
    documentation: DocumentationEditDto = undefined;
    roles: UserRoleDto[];
    roleAllNames = '';

    profilePicture: string;

    userHasRoleMember = true;
    userHasRoleNotMember = false;
    userMemberSaved: UserMemberEditDto = null;
    userAddressesSaved = [];
    editingCategoriaIndex = null;

    isResident = false;
    currentCategory: MemberCategoryEditDto = undefined;

    brazilStates: any[] = CorreiosService.loadBrazilStates();
    completeNameStateCrm = '';

    constructor(
        injector: Injector,
        private _userService: UserServiceProxy,
        private _profileService: ProfileServiceProxy

    ) {
        super(injector);
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');

        $('.datetimepicker').datetimepicker({
            locale: abp.localization.currentLanguage.name,
            format: 'L'
        });

        $('.tab-drop .nav-tabs').tabdrop({ text: this.l("more options"), align: 'right' });
    }

    show(userId?: number): void {

        this.active = true;
        this.currentCategory = undefined;
        this.completeNameStateCrm = '';
        this.documentation = undefined;

        this._userService.getUserForView(userId).subscribe(result => {

            if (!!result.user.id) {
                this.user = result.user;

                this.documentation = result.documentation;
            }

            this.roles = result.roles;

            this.getProfilePicture(result.profilePictureId);

            this.modal.show();

            this.checkRolesActived();
            this.verifyIsResisdent();

            if(this.user && this.user.member) {
                this.completeNameStateCrm = this.getCompleteStateName(this.user.member.crmUf);
            }
        });
    }

    getProfilePicture(profilePictureId: string): void {
        if (!profilePictureId) {
            this.profilePicture = '/assets/common/images/default-profile-picture.png';
        } else {
            this._profileService.getProfilePictureById(profilePictureId).subscribe(result => {

                if (result && result.profilePicture) {
                    this.profilePicture = 'data:image/jpeg;base64,' + result.profilePicture;
                } else {
                    this.profilePicture = '/assets/common/images/default-profile-picture.png';
                }
            });
        }
    }

    onShown(): void { }

    onHidden(): void {
        this.close();
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }

    checkRolesActived(): void {
        let rolesMember = _.filter(this.roles, { isAssigned: true, isMember: true });
        let rolesSelected = _.filter(this.roles, { isAssigned: true });

        if(rolesMember.length > 0) {
            this.userHasRoleMember = true;
        }
        else {
            this.userHasRoleMember = false;
        }

        this.roleAllNames = '';

        for (let j = 0; j < rolesSelected.length; j++) {
            if (this.roleAllNames.length) {
                this.roleAllNames = this.roleAllNames + ', ';
            }

            this.roleAllNames = this.roleAllNames + this.l(rolesSelected[j].roleName);
        }

        if(rolesSelected.length - rolesMember.length > 0)
            this.userHasRoleNotMember = true;
        else
            this.userHasRoleNotMember = false;

        setTimeout(() => {
            $('.tab-drop .nav-tabs').tabdrop({ text: this.l("more options"), align: 'right' });
        }, 100);
    }


    verifyIsResisdent(): void {

        this.isResident = false;
        this.currentCategory = undefined;

        if(this.user && this.user.member && this.user.member.categories.length > 0)
        {
            let categories = _.filter(this.user.member.categories, { endDate: undefined });
            if(categories.length > 0 && categories[0].category.isResident) {
                this.isResident = true;
            }

            this.currentCategory = categories[0];
        }
    }

    getCompleteStateName(state: string): string {

        let stateName = ''

        if(state) {

            this.brazilStates.forEach(x => {

                if (state == x.abbreviation) {

                    stateName = x.name;
                    return;
                }
            });
        }

        return stateName;
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/visualize-user-modal.component.ts